/**
 * @param props.color : a hex color to set stroke or fills color of svg path
 * @param props.size : set the icon size, see getSize for expected values
 * @param props.className : a tailwind class the would be implemented on span tag
 */

interface CaretDownProps {
    color?: string
    size?: string
    className?: string
}

const IconCaretDown = (props: CaretDownProps) => {
    const { className = '', color = '#364152' } = props
    return (
        <span className={'flex items-center justify-center ' + className}>
            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.4467 5.45334H8.29341H4.55341C3.91341 5.45334 3.59341 6.22667 4.04674 6.68001L7.50008 10.1333C8.05341 10.6867 8.95341 10.6867 9.50674 10.1333L10.8201 8.82L12.9601 6.68001C13.4067 6.22667 13.0867 5.45334 12.4467 5.45334Z" fill={color} />
            </svg>

        </span>
    )
}

export default IconCaretDown
